import { useListFunctionRole, useListMenu } from "hooks";
import MetisMenu from "metismenujs";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import SimpleBar from "simplebar-react";
import ConfigMenu from "./ConfigMenu";

const SidebarContent = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t, i18n } = useTranslation(["menuManagement"]);
  const { addToast } = useToasts();
  const ref = useRef();

  const [listMenuConfig, setListMenuConfig] = useState([]);
  const [isMenuLoaded, setIsMenuLoaded] = useState(false);

  // List Function Role
  const onSuccessListFunctionRole = data => {};
  const { refetch: listFunctionRole } = useListFunctionRole(
    { params: {}, isEnabled: true },
    onSuccessListFunctionRole
  );

  // List Menu
  const onSuccessMenuList = data => {
    if (data.items && data.items.length > 0) {
      setListMenuConfig(data.items);
    }
  };
  const { refetch: listMenu, remove: resetMenu } =
    useListMenu(onSuccessMenuList);

  // Load Menu Every Time Change "Link" Or Change "language"
  useEffect(() => {
    listMenu();
    return () => {
      resetMenu();
      setListMenuConfig([]);
      setIsMenuLoaded(false);
      ref.current.recalculate();
    };
  }, [dispatch, t, location.pathname]);

  // Find Active Menu
  useEffect(() => {
    const pathName = location.pathname;

    if (pathName && listMenuConfig.length > 0 && !isMenuLoaded) {
      setIsMenuLoaded(true);
      initMenu(pathName);
      ref.current.recalculate();
    }
  }, [isMenuLoaded, listMenuConfig, location.pathname]);

  const initMenu = pathName => {
    new MetisMenu("#side-menu");
    // mm.dispose();
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }

      const dataHref = items[i].attributes.datahref;
      if (dataHref && dataHref.value) {
        const arrHref = dataHref.value.split("___");
        if (arrHref.some(x => x === pathName)) {
          matchingMenuItem = items[i];
          break;
        }
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
    // mm.update();
  };

  const scrollElement = item => {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  };

  const activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">Menu</li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                {/* <span className="badge rounded-pill bg-info float-end">04</span> */}
                <span>Dashboards</span>
              </Link>
            </li>
            <li>
              <Link to="/my-orders" className="">
                <i className="bx bx-receipt"></i>
                {/* <span className="badge rounded-pill bg-info float-end">04</span> */}
                <span>Đơn của tôi</span>
              </Link>
            </li>
            {listMenuConfig && listMenuConfig.length > 0 && (
              <ConfigMenu menuApi={listMenuConfig} />
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default SidebarContent;
